import { useRSStore } from '../store/useRSStore'
import { useUserStore } from '../store/useUserStore'
import { readModelListAPI, addModelAPI, updateModelAPI, deleteModelAPI, paginationModelAPI } from '../api/ModelAPI'

import type { model, addmodel, modelfilter } from '../types/types'


export function useModel() {
  const RSStore = useRSStore()
  const UserStore = useUserStore()
  const onReadModelList = async (modelfilter: modelfilter) => {
    try {
      const list = await readModelListAPI(modelfilter)
      RSStore.modelList = list
    } catch (e) {
      console.error("모델 데이터를 가져오는 중 에러 발생:", e)
    }
  }

  const onAddModel = async (addModel: addmodel) => {
    try {
      const result = await addModelAPI(addModel)
      console.log("모델 추가 완료 id:", result)
    } catch (e) {
      console.error("모델 추가 중 에러 발생:", e)
    }
  }

  const onUpdateModel = async (model: model) => {
    try {
      const result = await updateModelAPI(model)
      if (result) {
        console.log("모델 업데이트 완료 :", model)
      } else {
        console.error("모델 업데이트 실패 입력값 확인 필요:", model)
      }
    } catch (e) {
      console.error("모델 업데이트 중 에러 발생:", e)
    }
  }

  const onDeleteModel = async (id: number) => {
    try {
      const result = await deleteModelAPI(id)
      if (result) {
        console.log("모델 삭제 완료 id:", id)
      } else {
        console.error("모델 삭제 실패 id:", id)
      }
    } catch (e) {
      console.error("모델 삭제 중 에러 발생:", e)
    }
  }

  const onPaginationModel = async (size: number) => {
    try {
      const result = await paginationModelAPI(size, UserStore.modelfilter.chipset_id) ?? 0
      return result
    } catch (e) {
      console.error("모델 페이지 수 가져오는 중 에러 발생:", e)
    }
  }
  return {
    onReadModelList,
    onAddModel,
    onUpdateModel,
    onDeleteModel,
    onPaginationModel,
  }
}